import React, { useEffect, useState } from 'react';
import { Link } from 'react-router-dom';
import { CompanyLegalDetails } from '../components/CompanyLegalDetails';
import { ETAPPIO_COMPANY } from '../constants/company';
import { systemApi, type PrivacyPolicyDocument } from '../services/api';

const formatSavedDate = (value: string) =>
  new Intl.DateTimeFormat('sv-SE', {
    year: 'numeric',
    month: 'long',
    day: 'numeric'
  }).format(new Date(value));

export function PrivacyPolicy() {
  const [document, setDocument] = useState<PrivacyPolicyDocument | null>(null);
  const [failed, setFailed] = useState(false);

  useEffect(() => {
    window.document.title = 'Integritets- och cookiepolicy för Etappio';
    systemApi.getPrivacyPolicy()
      .then(setDocument)
      .catch(() => setFailed(true));
  }, []);

  return (
    <div className="min-vh-100 bg-light d-flex flex-column">
      <header className="bg-white border-bottom py-3">
        <div className="container d-flex align-items-center justify-content-between">
          <Link to="/" aria-label="Etappio startsida">
            <img src="/assets/images/logo-full.png" alt="ETAPPIO" height="38" />
          </Link>
          <Link to="/" className="btn btn-light-brand btn-sm">
            Till startsidan
          </Link>
        </div>
      </header>

      <main className="container py-5 flex-grow-1" style={{ maxWidth: '920px' }}>
        <article className="card border-0 shadow-sm">
          <div className="card-body p-4 p-md-5">
            <h1 className="fw-bold mb-2">Integritets- och cookiepolicy för Etappio</h1>

            {!document && !failed && (
              <div className="d-flex align-items-center gap-2 text-muted py-5" role="status">
                <span className="spinner-border spinner-border-sm" aria-hidden="true"></span>
                Hämtar aktuell integritets- och cookiepolicy…
              </div>
            )}

            {failed && (
              <div className="alert alert-danger mt-4" role="alert">
                Aktuell integritets- och cookiepolicy kan inte visas just nu. Försök igen senare eller kontakta{' '}
                <a href={`mailto:${ETAPPIO_COMPANY.email}`}>{ETAPPIO_COMPANY.email}</a>.
              </div>
            )}

            {document && (
              <>
                <p className="text-muted border-bottom pb-3 mb-4" data-testid="privacy-version">
                  Version {document.version} · Senast uppdaterad{' '}
                  <time dateTime={document.savedAt}>
                    {formatSavedDate(document.savedAt)}
                  </time>
                </p>
                <div
                  className="ql-editor p-0"
                  data-testid="privacy-content"
                  dangerouslySetInnerHTML={{ __html: document.content }}
                />
              </>
            )}
          </div>
        </article>
      </main>

      <footer className="bg-dark text-white py-4">
        <div className="container text-center">
          <p className="small text-white-50 mb-2">© 2026 {ETAPPIO_COMPANY.legalName}</p>
          <CompanyLegalDetails variant="compact" theme="dark" />
        </div>
      </footer>
    </div>
  );
}
